import * as React from 'react';

import { createIcon } from '../Icon';
export const AlignCenterIcon = createIcon(
  <React.Fragment>
    <line x1={18} y1={10} x2={6} y2={10} />
    <line x1={21} y1={6} x2={3} y2={6} />
    <line x1={21} y1={14} x2={3} y2={14} />
    <line x1={18} y1={18} x2={6} y2={18} />
  </React.Fragment>,
  'AlignCenterIcon'
);
